import { get, post } from './http-calls';

export let getTCardUserHolidayType = async (id) => {
    let data = await get(`TCardUserHolidayType/TCardUserHolidayType_GetDetails?TCardUserHolidayTypeID=${id}`, { useAuthToken: true });
    return data;
};

export const postTCardUserHolidayType = async (data) => {
    let res = await post(`TCardUserHolidayType/TCardUserHolidayType_AddUpdate`, data, { useAuthToken: true });
    return res;
};
